import script from "./FlowContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowContent.vue?vue&type=script&setup=true&lang=js"

import "./FlowContent.vue?vue&type=style&index=0&id=45ce0206&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ce0206"]])

export default __exports__